import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { Pricing } from '../components/Pricing';
import { ParallaxDivider } from '../components/ParallaxDivider';
import { Gallery } from '../components/Gallery';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
export function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return <main data-id="element-207">
      <Hero data-id="element-208" />
      <About data-id="element-209" />
      <Services data-id="element-210" />
      <Pricing data-id="element-211" />
      <ParallaxDivider data-id="element-212" />
      <Gallery data-id="element-213" />
      <Testimonials data-id="element-214" />
      <Contact data-id="element-215" />
    </main>;
}